<template>
    <div class="risk-result">
        <!--  <div class="risk-head"></div> -->
        <div class="result-main">
            <div class="resultHead"></div>
            <div class="resultContent">
                <div class="maskTitle">{{ ratingLevelStr }}</div>
                <p>{{ remark }}</p>
                <span>测评时间：{{ riskAssessmentTime }}</span>
            </div>
            <div class="result-btn" @click="retry">重新测评</div>
        </div>
    </div>
</template>
<script>
import { callHandler } from "@/utils/bridge.js";
import sensors from "sa-sdk-javascript";

export default {
    data() {
        return {
            token: "",
            ratingLevelStr: "",
            remark: "",
            assessmentType: "",
            riskAssessmentTime: ""
        };
    },
    beforeMount() {
        const urlParams = this.$queryUrl(location.href);
        // const { token = "1c136f7c60ff7ba244f7ef73feb450f1:1", ratingLevelStr = "进取型", remark = "较高的风险承受能力", assessmentType = "4", riskAssessmentTime = "2019-08-08" } = urlParams; //测试数据
        const { token, ratingLevelStr, remark, assessmentType, riskAssessmentTime } = urlParams; //测试数据
        this.token = decodeURIComponent(token);
        this.ratingLevelStr = decodeURIComponent(ratingLevelStr);
        this.remark = decodeURIComponent(remark);
        this.assessmentType = assessmentType;
        this.riskAssessmentTime = riskAssessmentTime;
        sensors.track("TMRiskResult", {
            evaluation_title: this.ratingLevelStr,
            evaluation_result: this.remark,
            evaluation_time: this.riskAssessmentTime
        });
        callHandler("xhNaviGoBack", "webOpenUrl-" + location.origin + location.pathname + "#/riskQueue?token=" + token); //跳转到测评列表页面
    },
    methods: {
        retry() {
            this.$router.push({
                name: "riskAssessment",
                query: {
                    token: this.token,
                    assessmentType: this.assessmentType,
                    type: "retry"
                }
            });
        }
    }
};
</script>
<style lang="less">
.risk-result {
    width: 100%;
    box-sizing: border-box;
    /*  .risk-head {
        width: 100%;
        height: 160px;
        background-image: linear-gradient(270deg, #2b2632 0%, #53505a 99%);
    } */

    .result-main {
        /*  width:100%; */
        margin: 55px 28px 0;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .resultHead {
            width: 100%;
            height: 80px;
            background: url("../../../assets/images/normal/dialog_evaluat.png") no-repeat;
            background-size: 100% auto;
            margin: -30px auto 0;
        }

        .maskTitle {
            font-size: 18px;
            color: #333333;
        }

        .resultContent {
            width: 100%;
            background: #ffffff;
            box-shadow: 0 0 8px 0 #ebebeb;
            border-radius: 0 0 8px 8px;
            border-radius: 0px 0px 8px 8px;
            padding: 32px 0 36px;
            text-align: center;

            p {
                font-size: 14px;
                color: #888888;
                line-height: 22px;
                margin: 12px auto 24px;
            }

            span {
                font-size: 12px;
                color: #aaaaaa;
            }
        }
    }

    .result-btn {
        width: 100%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        margin-top: 40px;
        background-image: linear-gradient(90deg, #d0b77b 0%, #b89659 100%);
        border-radius: 4px;
    }
}
</style>
